import { AsyncState } from "types/store";

export const createInitialAsyncState = <T>(): AsyncState<T> => ({
  data: undefined,
  status: "idle",
  error: undefined,
});
